module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "id": "svg__computer",
      "viewBox": "0 0 400 400"
    }
  }, [_c('defs', [_c('linearGradient', {
    attrs: {
      "id": "lightGradient",
      "x1": "1",
      "x2": "0"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "white",
      "stop-opacity": "0.2"
    }
  }), _c('stop', {
    attrs: {
      "offset": "100%",
      "stop-color": "white",
      "stop-opacity": "0"
    }
  })], 1)], 1), _c('path', {
    staticClass: "screen--rotate",
    attrs: {
      "id": "screen",
      "d": "\n    M200,200\n    l0,-150\n    l15,0\n    q20,150 0,300\n    h-15\n    z\n  "
    }
  }), _c('path', {
    attrs: {
      "id": "stand",
      "d": "\n    M210,210\n    q20,-50 80,80\n    q40,90 0,90\n    l-100,0\n  "
    }
  }), _c('rect', {
    attrs: {
      "id": "table",
      "x": "130",
      "y": "383",
      "rx": "10",
      "ry": "10",
      "width": "375",
      "height": "75"
    }
  }), _c('path', {
    staticClass: "screen--rotate",
    attrs: {
      "id": "light",
      "d": "\n    M198,41\n    l0,300\n    l-30,15\n    l0,-330\n    z\n  ",
      "fill": "url(#lightGradient)"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-477fee09"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/container/index/components/Cover/svg/Computer/Computer.vue
// module id = 63
// module chunks = 0